export const MenuToList = [
    {
       name: 'Home' ,
       icon: 'home',
       path: '/'
    },
    {
       name: 'Search' ,
       icon: 'search',
        path: '/search'
    },
    {
       name: 'Inbox' ,
       icon: 'mail',
        path: '/inbox'
    },
    {
        name: 'Strategy' ,
        icon: 'target',
        path: '/strategy'
    },
    {
        name: 'Library' ,
        icon: 'book-open',
        path: '/library'
    },
    {
        name: 'Scan' ,
        icon: 'radio',
        path: '/scan'
    },
    {
        name: 'Projects' ,
        icon: 'layers',
        path: '/projects'
    }
] 
export const UltraWideMenuToList = [
    {
       name: 'Risk Universe' ,
        icon: 'globe',
        path: '/'
    },
    {
       name: 'EYRN AI' ,
        icon: 'eyrn',
        path: '/eyrnai'
    },
    {
        name: 'Strategy' ,
        icon: 'target',
        path: '/strategy'
    },
    {
        name: 'Risk Library' ,
        icon: 'book-open',
        path: '/library'
    },
    {
        name: 'Projects' ,
        icon: 'trello',
        path: '/projects'
    },
    {
        name: 'Inbox',
        icon: 'mail',
        path: '/inbox'
    },
    {
        name: 'Apps',
        icon: 'grid',
        path: '/apps'
    }
] 


export const MenuBottomList = [
    {
        name: 'Support',
        icon: 'life-buoy',
        path: '/support'
    },
    {
        name: 'Settings',
        icon: 'settings',
        path: '/settings'
    },
] 